// assets/custom.js
console.log('🔥 custom.js caricato');
(function() {
  // prendiamo l'header con id o classe
  const header = document.getElementById('header') || document.querySelector('.header');
  if (!header) return;

  let lastY = window.scrollY;

  window.addEventListener('scroll', function() {
    const currentY = window.scrollY;
    if (currentY > lastY && currentY > 20) {
      // scroll down: nascondi
      header.classList.add('header--hidden');
    } else {
      // scroll up o top: mostra
      header.classList.remove('header--hidden');
    }
    lastY = currentY;
  }, { passive: true });
})();


// assets/custom.js
document.addEventListener('DOMContentLoaded', function() {
  // applichiamo solo su schermi <= 768px
  if (window.innerWidth > 768) return;

  // selettore del tuo header fisso (pill-shaped)
  var header = document.querySelector('theme-header#header.header') 
               || document.querySelector('.header');

  if (!header) return;

  // misura l'altezza effettiva
  var h = header.getBoundingClientRect().height;

  // aggiunge padding-top al primo wrapper dopo il header
  var first = header.nextElementSibling;
  if (first) {
    first.style.paddingTop = h + 'px';
  }
});
